
import withRoute from "@xem/router/classes/withRoute";
import A from '@gqlapp/test/a';

export default function (props){
	return withRoute(A)({ ...props, ...{ webType: 'page', unloginedClass: '', classNameOnPage: 'theme-page', runtimejs: true, style:{ '--page-header-height': '0px !important' }}})
}

